import { Notification, NotificationType } from '../../types';
import { NotificationItemAction } from './notification-item-action';
import { NotificationItemDefault } from './notification-item-default';
import { NotificationItemTimeTrackingReminder } from './notification-item-time-tracking-reminder';
import { NotificationItemUnassignedTime } from './notification-item-unassigned-time';
import { NotificationItemWorklogList } from './notification-item-worklog-list';

interface NotificationItemProps {
  notification: Notification;
  onMarkAsRead?: (notificationId: number) => void;
  onDelete?: (notificationId: number) => void;
  onAction?: (notificationId: number) => void;
}

/**
 * Notification item component that renders different layouts based on notification type.
 */
export function NotificationItem({
  notification,
  onMarkAsRead,
  onDelete,
  onAction,
}: NotificationItemProps) {
  switch (notification.type) {
    case NotificationType.BASE_ACTION:
      return (
        <NotificationItemAction
          notification={notification}
          onMarkAsRead={onMarkAsRead}
          onDelete={onDelete}
          onAction={onAction}
        />
      );
    case NotificationType.TIME_TRACKED_WITHOUT_ASSIGNMENT:
      return (
        <NotificationItemUnassignedTime
          notification={notification}
          onMarkAsRead={onMarkAsRead}
          onDelete={onDelete}
        />
      );
    case NotificationType.TIME_TRACKING_WEEKLY_REMINDER:
    case NotificationType.TIME_TRACKING_MONTHLY_REMINDER:
      return (
        <NotificationItemTimeTrackingReminder
          notification={notification}
          onMarkAsRead={onMarkAsRead}
          onDelete={onDelete}
        />
      );
    case NotificationType.WORKLOG_APPROVED_SYNC_CONFLICT:
      return (
        <NotificationItemWorklogList
          notification={notification}
          onMarkAsRead={onMarkAsRead}
          onDelete={onDelete}
        />
      );
    case NotificationType.DEFAULT:
    default:
      return (
        <NotificationItemDefault
          notification={notification}
          onMarkAsRead={onMarkAsRead}
          onDelete={onDelete}
        />
      );
  }
}
